import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
	MATERIALREQUEST_PENDING_LIST,
	// MATERIALREQUEST_ROW_LIST,
	PURCHASEINDENT_LIST,
	MY_PURCHASEINDENT_LIST,
	MY_PI_LIST_COUNT,
	PI_LIST_COUNT,
	MR_SELECT_ITEM,
	PURCHASEINDENT_ROW,
	PURCHASEINDENT_ADD,
	PI_MODEL_LIST_OPEN,
	PI_ITEM_HOD_APPROVAL,
	// PII_DEPT_HOD_APPROVAL,
	PI_HOD_APPROVE_ADD,
	PI_PRODUCTS_REQUEST_LIST,
	PRODUCTS_ROW_REQUEST,
	PURCHASEINDENT_DELETE,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	PRODUCT_STORE_QTY,
	MR_DETAILS_MODEL_OPEN,
	PI_MR_ITEM_IMAGES,
} from "./actionTypes";
import {
	apiError,
	MRListSuccessful,
	// getMRRowListSuccessful,
	productstListSuccessful,
	// PISelectedItems,
	MyPIListSuccessful,
	getPIReqestRowDetails,
	pintRequestsuccessfull,
	PIRowloading,
	PIListCountSuccessful,
	productRowSuccessful,
	getProductStoreQtySuccessful,
	MRRowDataSuccessful,
	getMrItemImageSuccess,
	getProductStoreQty,
} from "./actions";

import {
	postAdd,
	getList,
	getParamsList,
	postEdit,
	postDelete,
} from "../../helpers/Helper";
import swal from "sweetalert";

// function* getMaterialRequestsPendingList({ payload }) {
//
//   try {
//     const response = yield call(
//       getParamsList,
//       "/materialrequest/pilist",
//       payload.data
//     );
//
//     yield put(MRListSuccessful({ response }));
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }
function* getMaterialRequestsselectList({ payload }) {
	var data = payload.data;
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "id") {
				params.id = data.id.join(",");
			} else if (k === "pistatus") {
				if (data.pistatus[0] !== 0) {
					params.pistatus = data.pistatus.join(",");
				}
			} else if (k === "MRcurrentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.MRcurrentSort;
			} else {
				if (
					data[k] !== "" &&
					k !== "no_of_pages" &&
					k !== "currentSort"
				) {
					params[k] = data[k];
				}
			}
		}
	}

	try {
		const response = yield call(
			getParamsList,
			"/materialrequest/pilistitem",
			params
		);
		yield put(MRListSuccessful(response));
		yield all(
			response.results.map((item) => {
				return put(getProductStoreQty(item.product.id));
			})
		);
	} catch (error) {
		yield put(apiError(error));
	}
}

function* GetMRDetails({ payload: { MRID } }) {
	try {
		const response = yield call(getList, "/materialrequest/" + MRID, {});
		yield put(MRRowDataSuccessful(response));
	} catch (error) {
		yield put(MRRowDataSuccessful(null));
		swal("Error in getting MR data from the Server", {
			icon: "error",
		});
	}
}

function* getMRItemImages({ payload: { mrItemId } }) {
	try {
		const response = yield call(
			getList,
			"/materialrequest/mritemimage/mritem/" + mrItemId,
			{}
		);
		yield put(getMrItemImageSuccess(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* productStoreQty({ payload: { ProductID } }) {
	try {
		const response = yield call(
			getList,
			"/focus/stock/" + ProductID, //USE THIS FOR FOCUS INTEGRATION
			// "/masters/user/inventory/product/" + ProductID,//USE THIS FOR WITH OUT FOCUS INTEGRATION
			{}
		);
		yield put(getProductStoreQtySuccessful({ response, ProductID }));
	} catch (error) {
		yield put(getProductStoreQtySuccessful(null));
		swal("Error in getting Stock data from the Server", {
			icon: "error",
		});
	}
}
function* getProductRequestList({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "pistatus") {
				if (data.pistatus[0] !== 0) {
					params.pistatus = data.pistatus.join(",");
				}
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}

	try {
		const response = yield call(
			getParamsList,
			"/masters/mini/products/",
			params
		);

		yield put(productstListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getProductRow({ payload }) {
	try {
		const response = yield call(
			getList,
			"/masters/products/" + payload.id,
			{}
		);
		yield put(productRowSuccessful({ response }));
	} catch (error) {
		yield put(apiError(error));
	}
}
// function* getMaterialRequestsRowList({ payload: { data } }) {
//
//   var params = {};

//   for (const k in data) {
//     if (Object.hasOwnProperty.call(data, k)) {
//

//       if (k === "mrstatus") {
//         if (data.mrstatus[0] !== 0) {
//           params.mrstatus = data.mrstatus.join(",");
//         }
//       } else {
//         if (data[k] !== "" && k !== "MrId" && k !== "Index") {
//           params[k] = data[k];
//         }
//       }
//     }
//   }
//   try {
//     const response = yield call(
//       getParamsList,
//       "/materialrequest/pilistitem/" + data.MrId,
//       params
//     );
//     var responsedata = response.results.map((p) => {
//       p.qty = p.availableqty;
//       return p;
//     });
//     yield put(getMRRowListSuccessful(responsedata));
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }
function* getPurchaseIndentsList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "pistatus") {
				if (data.pistatus[0] !== 0) {
					params.pistatus = data.pistatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (
					data[k] !== "" &&
					k !== "no_of_pages" &&
					k !== "MRcurrentSort"
				) {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/purchaseindent/mydeprequests",
			params
		);

		yield put(MyPIListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getMyPurchaseIndentsList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "pistatus") {
				if (data.pistatus[0] !== 0) {
					params.pistatus = data.pistatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (
					data[k] !== "" &&
					k !== "no_of_pages" &&
					k !== "MRcurrentSort"
				) {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/purchaseindent/myrequests",
			params
		);

		yield put(MyPIListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getMyPIListCount() {
	try {
		const response = yield call(
			getParamsList,
			"/purchaseindent/count/myrequests",
			{}
		);
		yield put(PIListCountSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getPIListCount() {
	try {
		const response = yield call(
			getParamsList,
			"/purchaseindent/count/mydeprequests",
			{}
		);
		yield put(PIListCountSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* PurchaseIndentRowlData({ payload }) {
	try {
		const response = yield call(getList, "/purchaseindent/" + payload.PIId);
		yield put(pintRequestsuccessfull(response));
	} catch (error) {
		swal(error, {
			icon: "error",
		});
	}
}
function* PurchaseIndentReqAdd({ payload: { data, PIId, history } }) {
	yield put(PIRowloading(true));
	try {
		if (PIId === "0") {
			const response = yield call(postAdd, "/purchaseindent/", data);
			if (response.status === 201) {
				yield put(PIRowloading(false));
				swal("Poof! Your Purchase Indent Added Successfully.!", {
					icon: "success",
				});

				history.push("/pidashboard");
			} else {
				yield put(PIRowloading(false));
				swal(
					"Sorry! Unable to add  Purchase Indent. Please Try Again!",
					{
						icon: "error",
					}
				);
			}
		} else {
			const response = yield call(
				postEdit,
				"/purchaseindent/" + PIId,
				data
			);
			if (response.status === 200) {
				yield put(PIRowloading(false));
				swal("Poof! Your  Purchase Indent Edited Successfully.!", {
					icon: "success",
				});
				history.push("/pidashboard");
			} else {
				yield put(PIRowloading(false));
				swal(
					"Sorry! Unable to edit  Purchase Indent. Please Try Again!",
					{
						icon: "error",
					}
				);
			}
		}
	} catch (error) {
		yield put(PIRowloading(false));
		swal("  Please Check the input fields and try again.", {
			icon: "error",
		});
	}
}

function* hodItemApproval({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/purchaseindent/mydeppiiapprove",
			data
		);

		if (response.status === 201) {
			swal(" Your Purchase Indent Item has been changed sucessfully!", {
				icon: "success",
			});

			yield put(PIRowloading(false));
			yield put(getPIReqestRowDetails(data.purchaseindent_id));
		} else {
			yield put(PIRowloading(false));
			swal(" Your Purchase Indent Item has been not changed!", {
				icon: "success",
			});
		}
	} catch (error) {
		yield put(PIRowloading(false));
		swal("Sorry! Error in getting from the Server!", {
			icon: "error",
		});
		yield put(apiError(error));
	}
}

// function* PIIDeptHodApproval({ payload: { data } }) {
//   try {
//     const response = yield call(
//       postAdd,
//       "/purchaseindent/mydeppiiapprove",
//       data
//     );

//     if (response.status === 201) {
//       if (data.pistatus === 3)
//         swal(" Your Purchase Indent Item has been approved sucessfully!", {
//           icon: "success",
//         });
//       else if (data.pistatus === 4) {
//         swal(" Your Purchase Indent Item has been Rejected sucessfully!", {
//           icon: "success",
//         });
//       }
//       yield put(PIRowloading(false));
//       yield put(getPIReqestRowDetails(data.purchaseindent_id));
//     } else {
//       yield put(PIRowloading(false));
//       if (data.pistatus === 3)
//         swal(" Your Purchase Indent Item has been not approved!", {
//           icon: "success",
//         });
//       else if (data.pistatus === 4) {
//         swal(" Your Purchase Indent Item has been not Rejected!", {
//           icon: "success",
//         });
//       }
//     }
//   } catch (error) {
//     yield put(PIRowloading(false));
//     swal("Sorry! Permission Denied!", {
//       icon: "error",
//     });

//     yield put(apiError(error));
//   }
// }
function* piHodApproveRequestAdd({ payload: { data, history } }) {
	yield put(PIRowloading(true));
	try {
		const response = yield call(
			postAdd,
			"/purchaseindent/mydeppiapprove",
			data
		);
		if (response.status === 201) {
			if (data.pistatus === 3)
				swal(" Your Purchase Indent has been approved sucessfully!", {
					icon: "success",
				});
			else if (data.pistatus === 4) {
				swal(" Your Purchase Indent has been Rejected sucessfully!", {
					icon: "success",
				});
			}

			yield put(PIRowloading(false));
			history.push("/pidashboard1");
		} else {
			if (data.pistatus === 3)
				swal(" Your Purchase Indent has been not approved!", {
					icon: "success",
				});
			else if (data.pistatus === 4) {
				swal(" Your Purchase Indent has been not Rejected!", {
					icon: "success",
				});
			}
			yield put(PIRowloading(false));
		}
	} catch (error) {
		yield put(PIRowloading(false));
		swal("This qty is not available in tagged MR.", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}
function* DeletePurchaseIndentRequest({ payload: { PIid, history } }) {
	try {
		const response = yield call(postDelete, "/purchaseindent/" + PIid);

		if (response.status === 204) {
			swal("Poof! Your Purchase Indent has been deleted!", {
				icon: "success",
			});
			history.push("/pidashboard");
		} else {
			swal("Sorry! Your  Purchase Indent has been not deleted!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}
/**
 *  the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
	switch (action) {
		case "add":
			if (document.body) document.body.classList.add(cssClass);
			break;
		case "remove":
			if (document.body) document.body.classList.remove(cssClass);
			break;
		default:
			if (document.body) document.body.classList.toggle(cssClass);
			break;
	}

	return true;
}

function* FilterShowRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled");
	} catch (error) {}
}
function* FilterHideRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
	} catch (error) {}
}
export function* watchgetMaterialRequesPendingtList() {
	yield takeEvery(
		MATERIALREQUEST_PENDING_LIST,
		getMaterialRequestsselectList
	);
}
// export function* watchgetMaterialRequesRowtList() {
//   yield takeEvery(MATERIALREQUEST_ROW_LIST, getMaterialRequestsRowList);
// }
export function* watchgetMRselectList() {
	yield takeEvery(MR_SELECT_ITEM, getMaterialRequestsselectList);
}
export function* watchgetProductRequestList() {
	yield takeEvery(PI_PRODUCTS_REQUEST_LIST, getProductRequestList);
}
export function* watchgetRowProductRequest() {
	yield takeEvery(PRODUCTS_ROW_REQUEST, getProductRow);
}
export function* watchgetMyPurcahseIndentList() {
	yield takeEvery(MY_PURCHASEINDENT_LIST, getMyPurchaseIndentsList);
}
export function* watchgetPurcahseIndentList() {
	yield takeEvery(PURCHASEINDENT_LIST, getPurchaseIndentsList);
}
export function* watchgetMyPICount() {
	yield takeEvery(MY_PI_LIST_COUNT, getMyPIListCount);
}
export function* watchgetPICount() {
	yield takeEvery(PI_LIST_COUNT, getPIListCount);
}
export function* watchPurchaseIndentRowDetails() {
	yield takeEvery(PURCHASEINDENT_ROW, PurchaseIndentRowlData);
}
export function* watchPurchaseIndentAdd() {
	yield takeEvery(PURCHASEINDENT_ADD, PurchaseIndentReqAdd);
}
export function* watchPurchaseIndentDeatislData() {
	yield takeEvery(PI_MODEL_LIST_OPEN, PurchaseIndentRowlData);
}
export function* watchItemHodApproval() {
	yield takeEvery(PI_ITEM_HOD_APPROVAL, hodItemApproval);
}
// export function* watchPIIDeptHodApproval() {
//   yield takeEvery(PII_DEPT_HOD_APPROVAL, PIIDeptHodApproval);
// }
export function* watchPIHodApproveRequestAdd() {
	yield takeEvery(PI_HOD_APPROVE_ADD, piHodApproveRequestAdd);
}
export function* watchPurchaseIndentDelete() {
	yield takeEvery(PURCHASEINDENT_DELETE, DeletePurchaseIndentRequest);
}
export function* watchFilterShowRightSidebar() {
	yield takeEvery(FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
	yield takeEvery(FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchProductStoreQty() {
	yield takeEvery(PRODUCT_STORE_QTY, productStoreQty);
}
export function* watchGetMRDetails() {
	yield takeEvery(MR_DETAILS_MODEL_OPEN, GetMRDetails);
}

export function* watchgetMRItemImages() {
	yield takeEvery(PI_MR_ITEM_IMAGES, getMRItemImages);
}
//-
function* PurchaseIndentSaga() {
	yield all([
		fork(watchgetMaterialRequesPendingtList),
		// fork(watchgetMaterialRequesRowtList),
		fork(watchgetMRselectList),
		fork(watchgetProductRequestList),
		fork(watchgetRowProductRequest),
		fork(watchgetMyPurcahseIndentList),
		fork(watchgetPurcahseIndentList),
		fork(watchgetMyPICount),
		fork(watchgetPICount),

		fork(watchPurchaseIndentRowDetails),
		fork(watchPurchaseIndentAdd),
		fork(watchItemHodApproval),
		// fork(watchPIIDeptHodApproval),
		fork(watchPIHodApproveRequestAdd),

		fork(watchPurchaseIndentDeatislData),
		fork(watchPurchaseIndentDelete),
		fork(watchProductStoreQty),
		fork(watchFilterShowRightSidebar),
		fork(watchfilterHideRightSidebarr),
		fork(watchGetMRDetails),

		fork(watchgetMRItemImages),
	]);
}

export default PurchaseIndentSaga;
